import { render } from "./medlifemedical.vue?vue&type=template&id=282768bc"
import script from "./medlifemedical.vue?vue&type=script&lang=js"
export * from "./medlifemedical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__